import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ children }) => {
      const { isLoggedIn, userData, loginModale } = useSelector(
    (state) => state.auth,
  );

    if(!isLoggedIn){
        return <Navigate to="/" replace/>
    }
    return children
}

export default PrivateRoute